import { FC, InputHTMLAttributes } from "react";

export const FormInputField: FC<
  InputHTMLAttributes<HTMLInputElement> & {
    label?: string;
  }
> = ({ label, value, ...props }) => {
  return (
    <label className="flex w-full flex-col">
      <span className="mb-2.5 text-sm font-medium leading-[22px] tracking-[-0.01em] text-[#232323]">
        {label}
      </span>
      <input
        className="h-[50px] rounded-[10px] border-[1px] border-solid border-[#DCDCDC] bg-[#FFFFFF] px-[12px] py-0"
        value={value || ""}
        {...props}
      />
    </label>
  );
};
